// extracted by mini-css-extract-plugin
export default {"multi_text_field_wrapper":"ImportPanel_multi_text_field_wrapper__0hhBN","send_button":"ImportPanel_send_button__SjTNa"};